import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'app-log-in-label',
  templateUrl: './log-in-label.component.html',
  imports: [TranslatePipe, IconComponent],
  host: { class: 'tw-inline-flex tw-items-center tw-gap-spacing-50' },
})
export class LogInLabelComponent {}
